import { Injectable, inject } from '@angular/core';
import { ApiDataAccess, ApiResourceLocation, Dictionary } from '@softline/core';
import {
  SOFTLINE_API_GARAGE_ORDER_ITEM_DEFAULT,
  SOFTLINE_API_PRODUCT_ORDER_ITEM_DEFAULT,
} from '../garage.api';
import { OrderItem } from '../models/order-item';
import { OrderTypeEnum } from '../models/order-type-enum';

@Injectable()
export class ItemTemplateRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  private createLocation(
    path: string,
    pathParams?: Dictionary<unknown>
  ): ApiResourceLocation {
    return pathParams ? { path, pathParams } : { path };
  }

  retrieve(
    request: Partial<OrderItem>,
    orderType: OrderTypeEnum = OrderTypeEnum.GARAGE
  ): Promise<OrderItem> {
    const path =
      orderType === OrderTypeEnum.PRODUCT
        ? SOFTLINE_API_PRODUCT_ORDER_ITEM_DEFAULT
        : SOFTLINE_API_GARAGE_ORDER_ITEM_DEFAULT;
    return this.#dataAccess.create(this.createLocation(path), request);
  }
}
